var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Week.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-76d23d98\",\"hasScoped\":false,\"transformToRequire\":{\"img\":[\"src\",\"srcset\"]}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Week.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/calendar/modules/Week.vue
// module id = r5b5
// module chunks = 3